import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  END_POINTS
} from '@/api'
// import * as dayjs from 'dayjs'
import * as Lodash from 'lodash'
// import * as Constants from '@/constant'
import * as Utils from '@/utils'
import * as StoreUtils from '@/utils/StoreUtils'

const SearchInfoBean = {
  compId: '',
  costColId: '',
  levelOneId: '',
  productName: '',
  END_SEARCH_INFO_BEAN: null
}

const InfoBean = {
  productId: '',
  compId: '',
  costColId: '',
  levelOneId: '',
  productName: '',
  seq: 0,
  crtBy: '',
  crtOn: null,
  updBy: '',
  updOn: null
}

const state = {
  searchInfo: { ...SearchInfoBean },
  searchedForm: { ...SearchInfoBean },
  list: [],
  info: {
    ...InfoBean
  },
  listPagging: Utils.getDefaultListPagging(),
  END_STATE: null
}

const getters = {

}

const actions = {
  ...StoreUtils.actions,
  insertPdName({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.INSERT_PD_NAME, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  updatePdName({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      putReq(END_POINTS.UPDATE_PD_NAME, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  removePdName({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      deleteSendReq(END_POINTS.REMOVE_PD_NAME + `/${key.compId}/${key.productId}`)
        .then(res => {
          state.info = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findPdName({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_PD_NAME + `/${key.compId}/${key.productId}`)
        .then(res => {
          state.info = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findPdNameList({
    commit,
    state,
    rootState
  }, { currentPage, pageSize }) {
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.FIND_PD_NAME_PAGE_LIST, {
        data: {
          currentPage,
          pageSize,
          queryVO: {
            compId: state.searchedForm.compId,
            costColId: state.searchedForm.costColId,
            levelOneId: state.searchedForm.levelOneId,
            productName: state.searchedForm.productName
          }
        }
      }).then(res => {
        state.list = res.data
        Utils.resetListPagging(state.listPagging, res)
        StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
      }).catch(err => {
        reject(err)
      })
    })
  },
  findPdNameDDList({
    commit,
    state,
    rootState
  }, { compId }) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_PD_NAME_DD_LIST + `/${compId}`)
        .then(res => {
          if (res.success) {
            const DDStore = Utils.getDDStore(res.data)
            // Utils.copyDDStore(DDStore, state.pdNameDDStore)
            resolve(DDStore)
          } else {
            StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
          }
        }).catch(err => {
          reject(err)
        })
    })
  },
  END_ACTIONS() {}
}

const mutations = {
  ...StoreUtils.mutations,
  resetSearchInfo(state) {
    state.searchInfo = { ...SearchInfoBean }
  },
  resetInfo(state) {
    state.info = { ...InfoBean }
  },
  addListItem(state, { index }) {
    state.list.splice(index, 0, { ...InfoBean })
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/conf/pdNameManage.js